import React, { useEffect, useMemo, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { initial, isEqual } from "lodash";
import { useDonationUIContext } from "../DonationPaymentUIContext";
import { statusDonasi, initialFilter } from "../DonationPaymentHelpers";
import moment from "moment";

import * as requestFt from "../../../../../../../MasterData/_redux/fund_type/fundtypeCrud";
import * as requestProj from "../../../../../../../MasterData/_redux/projects/projectsCrud";
import * as requestCh from "../../../../../../../MasterData/_redux/channels/channelsCrud";
import * as actions from "../../../../../../../MasterData/_redux/user/userAction";
import * as requestProg from "../../../../../../../MasterData/_redux/program/programCrud";
import { getBankAll } from "../../../../../../../MasterData/_redux/bank/bankCrud";
import {
  Input,
  Select,
} from "../../../../../../../../../_metronic/_partials/controls";

import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { getBranchAll } from "../../../../../../../MasterData/_redux/branchs/branchCrud";
// import * as requestDepartment from '../../../../../../../MasterData/_redux/department/departmentCrud';
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { getPaymentMethodAll } from "../../../../../../../MasterData/_redux/payment-method/pmCrud";
import { setDayWithOptions } from "date-fns/fp";
import { getBankAccountAll } from "../../../../../../../MasterData/_redux/bank-account/bankAccountCrud";

const prepareFilter = (queryParams, values) => {
  const {
    start_date,
    end_date,
    channel_type,
    channel_name,
    payment_method_uuid,
    bank_account_uuid,
    bank_uuid,
  } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.start_date = start_date ?? "";
  filter.end_date = end_date ?? "";
  filter.channel_type = channel_type ?? "";
  filter.channel_name = channel_name ?? "";
  filter.bank_uuid = bank_uuid ?? "";
  filter.bank_account_uuid = bank_account_uuid ?? "";
  filter.payment_method_uuid = payment_method_uuid ?? "";

  newQueryParams.filter = filter;
  return newQueryParams;
};

export const DonationFilter = ({ listLoading }) => {
  const { userAuth } = useSelector(
    (state) => ({ userAuth: state.auth.user }),
    shallowEqual
  );

  const donationUIContext = useDonationUIContext();
  const donationUIProps = useMemo(() => {
    return {
      setQueryParams: donationUIContext.setQueryParams,
      queryParams: donationUIContext.queryParams,
      filterType: donationUIContext.filterType,
      bankAccount: donationUIContext.bankAccount,
    };
  }, [donationUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(donationUIProps.queryParams, values);
    if (!isEqual(newQueryParams, donationUIProps.queryParams)) {
      if (userAuth.role === "MitraEchannel") {
        newQueryParams.filter.channel_uuid = userAuth.channel_uuid;
      }
      // newQueryParams.filter.bank_account_uuid = donationUIProps.bankAccount;
      newQueryParams.pageNumber = 1;
      console.log("newQueryParams", newQueryParams);
      donationUIProps.setQueryParams(newQueryParams);
    }
  };

  //UNTUK DATERANGE
  const [onFocused, setOnFocused] = useState(null);
  const [tanggal, setTanggal] = useState({
    start_date: donationUIProps.queryParams.filter.start_date
      ? moment(donationUIProps.queryParams.filter.start_date)
      : null,
    end_date: donationUIProps.queryParams.filter.end_date
      ? moment(donationUIProps.queryParams.filter.end_date)
      : null,
  });

  const [options, setOptions] = useState({
    payment_method: [],
    bank: [],
    bankAccount: [],
    channel: [],
  });
  useEffect(() => {
    getOptions();
  }, []);

  const getOptions = () => {
    getPaymentMethodAll().then((res) =>
      setOptions((prevState) => ({
        ...prevState,
        payment_method: res.data.data,
      }))
    );

    getBankAll()
      .then((res) =>
        setOptions((prevState) => ({
          ...prevState,
          bank: res.data.data,
        }))
      )
      .catch((err) => console.log(err));

    getBankAccountAll().then((res) =>
      setOptions((prevState) => ({
        ...prevState,
        bankAccount: res.data.data,
      }))
    );

    requestCh.channelGetAll().then((res) =>
      setOptions((prevState) => ({
        ...prevState,
        channel: res.data.data,
      }))
    );
  };

  return (
    <Formik
      initialValues={initialFilter.filter}
      enableReinitialize={true}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue, resetForm }) => (
        <>
          <form className="form form-label-right">
            {/*ROW 1*/}
            <div className="form-group row">
              <div className="col-lg-4">
                <DateRangePicker
                  small={true}
                  startDate={tanggal.start_date}
                  endDate={tanggal.end_date}
                  onDatesChange={({ startDate, endDate }) => {
                    setTanggal({
                      start_date: startDate,
                      end_date: endDate,
                    });
                    setFieldValue("start_date", startDate);
                    setFieldValue("end_date", endDate);
                  }}
                  focusedInput={onFocused}
                  onFocusChange={(focusedInput) => setOnFocused(focusedInput)}
                  numberOfMonths={1}
                  isOutsideRange={() => false}
                  showClearDates={true}
                  startDateId="start_date"
                  endDateId="end_date"
                  hideKeyboardShortcutsPanel={true}
                />
                <small className="form-text text-muted">
                  Cari rentan waktu untuk export <b>maksimal 1 bulan</b>
                </small>
              </div>
              <div className="col-lg-4">
                <Autocomplete
                  name="payment_method_uuid"
                  options={options.payment_method}
                  // defaultValue={reconcileData.uuid && { uuid: reconcileData.bank_pooling.uuid }}
                  value={
                    options.payment_method.length > 0 &&
                    options.payment_method.find(
                      (item) => item.uuid === values.payment_method_uuid
                    )
                  }
                  getOptionLabel={(option) => option.name}
                  onChange={(e, value) => {
                    if (value) {
                      setFieldValue("payment_method_uuid", value.uuid);
                    } else {
                      setFieldValue("payment_method_uuid", "");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Cari Payment Method"
                      variant="outlined"
                      // disableClearable
                      size="small"
                    />
                  )}
                />
                <small className="form-text text-muted">
                  <b>Cari</b> ID Donatur
                </small>
              </div>
              <div className="col-lg-4">
                <Autocomplete
                  name="bank_uuid"
                  options={options.bank}
                  // defaultValue={reconcileData.uuid && { uuid: reconcileData.bank_pooling.uuid }}
                  value={
                    options.bank.length > 0 &&
                    options.bank.find((item) => item.uuid === values.bank_uuid)
                  }
                  getOptionLabel={(option) => option.name}
                  onChange={(e, value) => {
                    if (value) {
                      setFieldValue("bank_uuid", value.uuid);
                    } else {
                      setFieldValue("bank_uuid", "");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Cari Bank"
                      variant="outlined"
                      // disableClearable
                      size="small"
                    />
                  )}
                />
                <small className="form-text text-muted">
                  <b>Cari</b> Bank
                </small>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-lg-4">
                <Autocomplete
                  name="bank_account_uuid"
                  options={options.bankAccount.filter(
                    (item) => item.bank_uuid === values.bank_uuid
                  )}
                  value={
                    options.bankAccount.length > 0 &&
                    options.bankAccount.find(
                      (item) => item.uuid === values.bank_account_uuid
                    )
                  }
                  getOptionLabel={(option) => option.account_number}
                  onChange={(e, value) => {
                    if (value) {
                      setFieldValue("bank_account_uuid", value.uuid);
                    } else {
                      setFieldValue("bank_account_uuid", "");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Cari Bank"
                      variant="outlined"
                      // disableClearable
                      size="small"
                    />
                  )}
                />
                <small className="form-text text-muted">
                  <b>Cari</b> Rekening Bank
                </small>
              </div>
              <div className="col-lg-4">
                <select
                  name="type"
                  label="Type"
                  className="form-control"
                  onChange={(e) => {
                    setFieldValue("channel_type", e.target.value);
                  }}
                >
                  <option value="">-PILIH-</option>
                  {/* <option value="BANK">BANK</option> */}
                  <option value="COUNTER">COUNTER</option>
                  <option value="ECHANNEL">ECHANNEL</option>
                </select>
                <small className="form-text text-muted">
                  <b>Cari</b> Tipe Channel
                </small>
              </div>
              <div className="col-lg-4">
                <Autocomplete
                  name="channel_name"
                  options={options.channel}
                  // defaultValue={reconcileData.uuid && { uuid: reconcileData.bank_pooling.uuid }}
                  value={
                    options.bank.length > 0 &&
                    options.bank.find(
                      (item) => item.uuid === values.channel_name
                    )
                  }
                  getOptionLabel={(option) => option.name}
                  onChange={(e, value) => {
                    if (value) {
                      setFieldValue("channel_name", value.name);
                    } else {
                      setFieldValue("channel_name", "");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Cari Nama Channel"
                      variant="outlined"
                      // disableClearable
                      size="small"
                    />
                  )}
                />
                <small className="form-text text-muted">
                  <b>Cari</b> Nama Channel
                </small>
              </div>
            </div>
          </form>

          <button
            onClick={() => handleSubmit()}
            className="btn btn-primary btn-elevate float-right mb-20 ml-3"
          >
            Cari
          </button>
          <button
            onClick={() => {
              resetForm();
              handleSubmit();
            }}
            className="btn btn-warning btn-elevate float-right mb-20"
          >
            Reset Pencarian
          </button>
          <hr className="mt-25" />
        </>
      )}
    </Formik>
  );
};
